module.exports = fox._r("images/sprite.png", __webpack_public_path__ + "_/_/_/common/frame/images/sprite.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/sprite.png
// module id = 0
// module chunks = 2